var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpBooksApiV5Request } from "./http-api-request.js";
export function listIntegrations(bookId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const res = yield new HttpBooksApiV5Request(`${bookId}/integrations`, config)
            .setMethod('GET')
            .fetch();
        return ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function createIntegration(bookId, integration, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield new HttpBooksApiV5Request(`${bookId}/integrations`, config)
            .setPayload(integration)
            .setMethod('POST')
            .fetch();
        return res.data;
    });
}
export function updateIntegration(bookId, integration, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield new HttpBooksApiV5Request(`${bookId}/integrations`, config)
            .setPayload(integration)
            .setMethod('PUT')
            .fetch();
        return res.data;
    });
}
export function deleteIntegration(bookId, id, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield new HttpBooksApiV5Request(`${bookId}/integrations/${id}`, config).setMethod('DELETE').fetch();
        return res.data;
    });
}
//# sourceMappingURL=integration-service.js.map